<template>
    <header class="hero">
        <div class="grid-container">
            <div class="hero--main grid-x">
                <div class="cell small-12">
                    <section class="grid-x grid-padding-x align-middle">
                        <h1 class="hero--title cell small-12 medium-6 show-for-medium small-order-2">
                            <img src="/netemosametemo/hamaguchi/static/img/tittle.png" alt="『寝ても覚めても』公開記念 濱口竜介アーリー・ワークス">
                            <strong class="seo">『寝ても覚めても』公開記念 濱口竜介アーリー・ワークス</strong>
                        </h1>

                        <figure class="hero--image cell small-12 medium-6 small-order-1">
                            <img src="/netemosametemo/hamaguchi/static/img/main_large.jpg" alt="『寝ても覚めても』公開記念 濱口竜介アーリー・ワークス">
                        </figure>
                    </section>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: 'hero',
    data () {
        return {
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Hero.vue